import styled from '@emotion/styled';

import { round } from '../../lib/math';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { theme } from '../../theme/theme';

export function IndicatorNumber({ device, capabilityId }) {
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: device.id,
    capabilityId,
  });

  const isMeasurePower = capabilityId.startsWith('measure_power');

  const renderValue = (() => {
    if (value == null) {
      return '-';
    }

    if (isMeasurePower === true) {
      if (value === 0) {
        return 0;
      }

      if (value < 0 && value > -1) {
        return Math.floor(value);
      }

      if (value > 0 && value < 1) {
        return Math.ceil(value);
      }

      return round(value, 0);
    }

    return round(value, capabilityObj?.decimals);
  })();

  const unitsPostFix = capabilityObj?.units ? ` ${capabilityObj.units}` : '';

  return (
    <IndicatorNumber.Root data-style-color={isMeasurePower === true ? 'green' : undefined}>
      {`${renderValue}${unitsPostFix}`}
    </IndicatorNumber.Root>
  );
}

IndicatorNumber.Root = styled.div`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.bold};
  max-width: 54px;
  text-align: end;
  word-break: break-word;

  &[data-style-color='green'] {
    color: #0ba95d;
  }
`;
